import { format, parseISO } from "date-fns";

//  date format in dd/mm/yyy
export function formatDate(date) {
  return format(new Date(date), "dd/MM/yyyy");
}

// date format as Mon, 27 Jan 2025 12:51:13
export function formatDateWithTime(date) {
  return format(new Date(date), "eee, dd MMM yyyy HH:mm:ss");
}

export function formatDateToMonthDayYearTime(dateString) {
  const date = parseISO(dateString);
  return format(date, "MMMM d, yyyy 'at' h:mm a");
}

export function formatDateTo12Hr(date) {
  if (!date) return "N/A";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return "N/A";
  return format(parsedDate, "hh:mm a");
}
export function calculateDaysDifference(providedDateString) {
  if (!providedDateString) return 0;
  const providedDate = new Date(providedDateString);
  if (isNaN(providedDate.getTime())) return 0;
  const currentDate = new Date();
  const differenceInTime = providedDate.getTime() - currentDate.getTime();
  return Math.floor(differenceInTime / (1000 * 3600 * 24));
}
